import { render, staticRenderFns } from "./RelationshipsEditContact.vue?vue&type=template&id=7ac10b71&"
import script from "./RelationshipsEditContact.vue?vue&type=script&lang=js&"
export * from "./RelationshipsEditContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports